import { Button, type ButtonProps, Typography } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import {
	cloneElement,
	type FC,
	isValidElement,
	type ReactElement,
	type ReactNode,
} from 'react';

interface EmptyStateProps {
	title: string;
	subTitle?: string;
	icon?: ReactNode;
	iconClassName?: string; // applied to the icon element
	iconWrapperClassName?: string; // applied to the circular wrapper
	buttonProps?: ButtonProps;
}

export const EmptyState: FC<EmptyStateProps> = ({
	title,
	subTitle,
	icon,
	buttonProps,
}) => (
	<div className="flex flex-col justify-center items-center my-space-40 max-mobile:my-space-24 max-w-[300px] mx-auto">
		{icon && (
			<div className="p-space-16 rounded-full bg-neutral-50 mb-space-16 text-neutral-600">
				{isValidElement(icon)
					? cloneElement(icon as ReactElement<{ className?: string }>, {
							className: clsx(
								(icon.props as { className?: string })?.className,
								'w-space-48 h-space-48',
							),
						})
					: icon}
			</div>
		)}
		<Typography className="mb-space-4" level="h2">
			{title}
		</Typography>
		{!!subTitle && (
			<Typography className="text-neutral-800 text-center" level="text">
				{subTitle}
			</Typography>
		)}
		{buttonProps?.children && <Button className="mt-space-24" {...buttonProps} />}
	</div>
);
